import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext';
import ManageFormsPage from './ManageFormsPage';

export default WithGASetup(ManageFormsPage, AuthContext);
